import {
  faArrowTrendDown,
  faArrowTrendUp,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { ReactNode } from 'react';
import LoadingIcon from '../Components/LoadingIcon';

interface StatCardProps {
  title: string;
  value: string;
  change: number;
  icon?: ReactNode;
  loading: boolean;
}

export const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  change,
  icon,
  loading,
}) => {
  return (
    <div className="flex flex-col justify-center md:min-w-[250px] min-h-[120px] bg-white rounded-lg p-4">
      {!loading ? (
        <>
          <div className="flex flex-col items-center mb-2">
            {icon && <div className="w-5 h-5 text-gray-600 mb-1">{icon}</div>}
            <div className="text-sm text-gray-500">{title}</div>
          </div>
          <div className="flex flex-col items-center">
            <div className="flex items-center gap-2">
              <div className="text-4xl font-bold">{value ?? 0}</div>
              {change !== 0 && (
                <div
                  className={`text-sm px-2 py-0.5 rounded-full flex items-center gap-1 ${
                    change > 0
                      ? 'text-green-700 bg-green-100'
                      : 'text-red-700 bg-red-100'
                  }`}
                >
                  <FontAwesomeIcon
                    icon={change > 0 ? faArrowTrendUp : faArrowTrendDown}
                    className="w-3 h-3"
                  />
                  <span>{Math.abs(change).toFixed(1)}%</span>
                </div>
              )}
            </div>
          </div>
        </>
      ) : (
        <LoadingIcon />
      )}
    </div>
  );
};
